var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.hideIcon)?_c('img',{attrs:{"src":require("@/assets/img/1x/communication-and-multimedia-sms.png"),"alt":"Icono celular y mensaje"}}):_vm._e(),_c('span',{staticClass:"disable-selection"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }